import { createContext } from "react";

export const IdTokenContext = createContext("")